import ESCSlider from './Slider'
import ThreeSixty from './ThreeSixty'

class ProductModal {
    constructor (theme, elem) {
        this._elem = elem
        this._theme = theme
        this.breakpoint = 480
        this.events = this.setEvents()
        this.handle = elem.dataset.productModal
        this.open = false
        this.trigger = elem.querySelector('[data-product-modal-trigger]') || elem
        this.data = {
            product: null,
            id: null,
            images: [],
            quantity: 1
        }
        this.modal = document.querySelector('[data-product-modal-container]')
        this.setup = false
        this.slider = {}
        this.url = `/products/${this.handle}.js`
    }

    onInit () {
        if (!this._elem.dataset.productModal) return false
        if (!this.modal) {
            this.setupBaseModal()
        }
        this._elem.productModal = this
        this.trigger.addEventListener('click', e => this.modalLogic(e))
    }

    init () {
        this.onInit()
    }

    turnOn () {
        this.open = true
        this.modal.classList.add('on')
        this.modal.dispatchEvent(this.events.initiated)
        document.body.classList.add('overlay')
        document.body.overlayStatus = true
        document.body.addEventListener('overlay-hit', e => {
            this.turnOff(true)
        })
        this.modal.modalRef = this
    }

    turnOff (overlay) {
        this.modal.classList.remove('on')
        this.modal.innerHTML = ''
        this.open = false
        if (!overlay) {
            document.body.classList.remove('overlay')
            document.body.overlayStatus = false
        }
    }

    setupBaseModal () {
        let elemLastBodyDiv = document.querySelectorAll('body > div')
        elemLastBodyDiv = elemLastBodyDiv[elemLastBodyDiv.length - 1]
        this.modal = this.createElem('div', false, 'product-modal', ['productModalContainer', 'bodyOverlayIgnore'])
        elemLastBodyDiv.parentNode.insertBefore(this.modal, elemLastBodyDiv.nextSibling)
    }

    modalLogic (evt) {
        if (window.innerWidth <= this.breakpoint) return true
        if (evt) evt.preventDefault()
        if (!this.data.product) {
            this.getProductData()
            return false
        }
        this.addProductData()
        this.addProductImages()
        this.initiateSlider()
        this.addClose()
        this.attachEvents()
        this.setup = true
        this.turnOn()
    }

    getProductData () {
        this.makeRequest(this.url, 'text').then(data => {
            let response = JSON.parse(data.response)
            this.data.product = response
            this.data.id = response.variants[0].id
            this.loadProductImages(response.images)
        })
    }

    loadProductImages (imgArr) {
        let loadCount = 0
        for (let img of imgArr) {
            this.makeRequest(img, 'img').then(data => {
                this.data.images.push(data)
                loadCount++
                if (imgArr.length === loadCount) {
                    this.modalLogic()
                }
            })
        }
    }

    makeRequest (url, type) {
        return new Promise((resolve, reject) => {
            let method = null
            if (type === 'json' || type === 'text') {
                method = new XMLHttpRequest()
                method.open('GET', url)
                method.responseType = type
            } else if (type === 'img') {
                method = new Image()
            }
            method.onload = e => {
                resolve(method)
            }
            method.onerror = e => {
                reject(method)
            }
            if (type === 'img') {
                method.src = url
            } else if (type === 'json' || type === 'text') {
                method.send()
            }
        })
    }

    createElem (type, content, className, data) {
        let retElem = document.createElement(type)
        if (content) {
            retElem.innerHTML = content
        }
        if (className) {
            retElem.classList.add(className)
        }
        if (data) {
            for (let item of data) {
                if (item.indexOf('=') > -1) {
                    let split = item.split('=')
                    retElem.dataset[split[0]] = split[1]
                    continue
                }
                retElem.dataset[item] = ''
            }
        }
        return retElem
    }

    addProductData () {
        let elemProductData = this.createElem('div', false, 'product-data')
        elemProductData.appendChild(this.createElem('h4', this.data.product.title, 'product-modal-title'))
        let elemProductInfo = this.createElem('div', false, 'product-modal-info')
        let productSize = false
        for (let tag of this.data.product.tags) {
            if (tag.indexOf('size-') !== 0) continue
            productSize = tag.split('-')[1]
        }
        if (productSize) elemProductInfo.appendChild(this.createElem('span', productSize, 'product-modal-size'))
        let elemPrice = this.createElem('span', false, 'product-modal-price')
        if (this.data.product.price < this.data.product.compare_at_price) {
            elemPrice.appendChild(this.createElem('span', this.formatMoney(this.data.product.price), 'current-price'))
            elemPrice.appendChild(this.createElem('span', '-'))
            elemPrice.appendChild(this.createElem('span', this.formatMoney(this.data.product.compare_at_price)), 'old-price')
        } else {
            elemPrice.innerHTML = this.formatMoney(this.data.product.price)
        }
        elemProductInfo.appendChild(elemPrice)
        elemProductData.appendChild(elemProductInfo)
        let productDescription = this.stripHTML(this.data.product.description).substr(0, 100)
        productDescription = productDescription.substr(productDescription.length - 1) === '.' ? productDescription + '..' : productDescription + '...'
        elemProductData.appendChild(this.createElem('p', productDescription, 'product-modal-description'))
        elemProductData.appendChild(this.addProductForm())
        let elemLearnMore = this.createElem('a', 'Learn More', 'product-modal-link')
        elemLearnMore.href = this.data.product.url
        elemLearnMore.title = 'Learn More'
        elemProductData.appendChild(elemLearnMore)
        this.modal.appendChild(elemProductData)
    }

    addProductForm () {
        let productForm = document.createElement('form')
        productForm.action = '/cart/add'
        productForm.method = 'post'
        productForm.enctype = 'multipart/form-data'
        this.addProductId(productForm)
        if (this.data.product.variants.length > 1) {
            this.addVariants(productForm)
        }
        this.addProductQuantity(productForm)
        this.addToCart(productForm)
        return productForm
    }

    addProductId (elem) {
        let elemProductId = this.createElem('input', false, 'product-id', ['productId'])
        elemProductId.type = 'hidden'
        elemProductId.name = 'id'
        elemProductId.value = this.data.product.variants[0].id
        elem.appendChild(elemProductId)
    }

    addToCart (elem) {
        let elemAddToCart = this.createElem('button', false, 'product-add-to-cart', ['modalAddToCart'])
        elemAddToCart.type = 'submit'
        elemAddToCart.appendChild(this.createElem('span', 'Add to cart', false))
        elem.appendChild(elemAddToCart)
    }

    addProductQuantity (elem) {
        let elemQuantityContainer = this.createElem('div', false, 'product-quantity-container')
        let elemQuantityInput = this.createElem('input', false, 'product-quantity-input', ['quantityInput'])
        elemQuantityInput.type = 'hidden'
        elemQuantityInput.id = 'Quantity'
        elemQuantityInput.name = 'quantity'
        elemQuantityInput.value = '1'
        elemQuantityContainer.appendChild(elemQuantityInput)
        elemQuantityContainer.appendChild(this.createElem('span', '-', 'qty-minus', ['quantityMinus']))
        let elemQuantity = this.createElem('span', 'Qty:', 'qty')
        elemQuantity.appendChild(this.createElem('span', '1', 'qty-control', ['quantityValue']))
        elemQuantityContainer.appendChild(elemQuantity)
        elemQuantityContainer.appendChild(this.createElem('span', '+', 'qty-plus', ['quantityPlus']))
        elem.appendChild(elemQuantityContainer)
    }

    addProductImages () {
        let elemProductImages = this.createElem('div', false, 'product-images')
        elemProductImages.classList.add('esc-slider-container')
        let elemProductSlider = this.createElem('div', false, 'esc-slider')
        let elemProductSliderWrapper = this.createElem('div', false, 'slider-wrapper')
        let elemProductThumbnails = this.createElem('ul', false, 'esc-slider-thumbnails', ['sliderThumbnails'])
        if (this._elem.dataset.loadThreeSixty) {
            elemProductThumbnails.appendChild(this.createElem('li', '<span>360 Product Viewer</span>', 'three-sixty', ['slideThumb']))
            let elemThreeSixtySlide = this.createElem('div', false, 'esc-slide')
            elemThreeSixtySlide.appendChild(this.createElem('div', false, 'three-sixty-viewer', [`threeSixty=${this._elem.dataset.loadThreeSixty}`]))
            elemProductSlider.appendChild(elemThreeSixtySlide)
        }
        for (let img of this.data.images) {
            let tempImg = document.createElement('img')
            tempImg.src = img.src
            let tempSlide = this.createElem('div', false, 'esc-slide')
            let tempThumb = this.createElem('li', false, false, ['slideThumb'])
            tempThumb.style.backgroundImage = `url(${img.src})`
            tempSlide.appendChild(tempImg)
            elemProductThumbnails.appendChild(tempThumb)
            elemProductSlider.appendChild(tempSlide)
        }
        elemProductSliderWrapper.appendChild(elemProductSlider)
        elemProductImages.appendChild(elemProductSliderWrapper)
        this.slider.settings = {
            arrows: true,
            dots: false,
            autoplay: false,
            interval: 1,
            pause: true,
            slidesPerView: 1,
            speed: 1
        }
        let keys = Object.keys(this.slider.settings)
        elemProductSlider.dataset.slider = ''
        elemProductSlider.dataset.sliderUseParentContainer = '.slider-wrapper'
        elemProductSlider.dataset.sliderThumbnailContainer = 'slider-thumbnails'
        for (var i = 0; i < keys.length; i++) {
            let key = keys[i]
            let item = this.slider.settings[key]
            let dataKey = key.substr(0, 1).toUpperCase() + key.substr(1, key.length)
            elemProductSlider.dataset[`sliderSetting${dataKey}`] = item
        }
        elemProductImages.appendChild(elemProductThumbnails)
        this.modal.appendChild(elemProductImages)
    }

    addVariants (elem) {
        this.data.variant = {}
        let tempVariantContainer = this.createElem('div', false, 'product-variant-container')
        for (var i = 0; i < this.data.product.variants.length; i++) {
            let tempVariant = this.createElem('div', false, 'product-variant')
            let currVariant = this.data.product.variants[i]
            let tempVariantInput = this.createElem('input', false, 'product-variant-input', [`variantId=${currVariant.id}`])
            tempVariantInput.type = 'radio'
            if (i === 0) {
                tempVariantInput.checked = true
                this.data.variant.current = tempVariantInput
            }
            let tempVariantLabel = this.createElem('label', false, 'product-variant-label', ['variantLabel'])
            tempVariantLabel.appendChild(this.createElem('span', currVariant.title))
            tempVariant.appendChild(tempVariantInput)
            tempVariant.appendChild(tempVariantLabel)
            tempVariantContainer.appendChild(tempVariant)
        }
        elem.appendChild(tempVariantContainer)
    }

    initiateSlider () {
        this.slider.elem = this.modal.querySelector('[data-slider]')
        this.slider.slider = new ESCSlider(this._theme, this.slider.elem)
        if (this._elem.dataset.loadThreeSixty) {
            this.slider.slider._elem.addEventListener('initiated', e => {
                for (let slide of this.slider.slider._slides) {
                    let threeSixtyViewer = slide.querySelector('[data-three-sixty]')
                    if (threeSixtyViewer) {
                        slide.threeSixty = new ThreeSixty(window.__Theme, threeSixtyViewer)
                        slide.threeSixty.init()
                    }
                }
            })
            this.slider.slider._elem.addEventListener('after-slide', e => {
                if (this.slider.slider.activeSlide.threeSixty) {
                    this.slider.slider.activeSlide.threeSixty.fullSpin()
                }
            })
        }
        this.slider.slider.init()
    }

    addClose () {
        let elemClose = this.createElem('span', 'Close', 'modal-close', ['productModalClose'])
        this.modal.appendChild(elemClose)
    }

    setEvents () {
        return {
            'initiated': new Event('initiated')
        }
    }

    attachEvents () {
        this.elems = {
            'addToCart': this.modal.querySelector('[data-modal-add-to-cart]'),
            'close': this.modal.querySelector('[data-product-modal-close]'),
            'qtyPlus': this.modal.querySelector('[data-quantity-plus]'),
            'qtyMinus': this.modal.querySelector('[data-quantity-minus]'),
            'qtyValue': this.modal.querySelector('[data-quantity-value]'),
            'qtyInput': this.modal.querySelector('[data-quantity-input]'),
            'variantLabels': this.modal.querySelectorAll('[data-variant-label]'),
            'variantInputs': this.modal.querySelectorAll('[data-variant-id]'),
            'productId': this.modal.querySelector('[data-product-id]')
        }
        if (this.elems.variantLabels.length > 0) {
            for (let [index, label] of this.elems.variantLabels.entries()) {
                label.addEventListener('click', e => {
                    this.data.variant.current.checked = false
                    this.data.variant.current = this.elems.variantInputs[index]
                    this.data.variant.current.checked = true
                })
            }
        }
        this.elems.close.addEventListener('click', evt => {
            evt.preventDefault()
            this.turnOff()
        })
        this.elems.qtyPlus.addEventListener('click', evt => {
            evt.preventDefault()
            this.data.quantity++
            this.elems.qtyValue.innerHTML = this.data.quantity
            this.elems.qtyInput.value = this.data.quantity
        })
        this.elems.qtyMinus.addEventListener('click', evt => {
            evt.preventDefault()
            if (this.data.quantity === 1) return false
            this.data.quantity--
            this.elems.qtyValue.innerHTML = this.data.quantity
            this.elems.qtyInput.value = this.data.quantity
        })
    }

    stripHTML (str) {
        let regEx = /(<([^>]+)>)/ig
        return str.replace(regEx, '')
    }

    formatMoney (cents, format) {
        if (typeof cents === 'string') { cents = cents.replace('.', '') }
        var value = ''
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/
        var formatString = (format || window.theme.moneyFormat)

        function defaultOption (opt, def) {
            return (typeof opt === 'undefined' ? def : opt)
        }

        function formatWithDelimiters (number, precision, thousands, decimal) {
            precision = defaultOption(precision, 2)
            thousands = defaultOption(thousands, ',')
            decimal = defaultOption(decimal, '.')

            if (isNaN(number) || number == null) { return 0 }

            number = (number / 100.0).toFixed(precision)

            var parts = number.split('.')
            var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands)
            var cents = parts[1] ? (decimal + parts[1]) : ''

            return dollars + cents
        }

        switch (formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2)
            break
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0)
            break
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',')
            break
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',')
            break
        }

        return formatString.replace(placeholderRegex, value)
    }
}

export default ProductModal



// WEBPACK FOOTER //
// ./src/scripts/components/ProductModal.js